module.exports = __webpack_public_path__ + "static/media/salubox-logo.1717fe0d.svg";